// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__c2IQM","modalAnim":"Modal_modalAnim__1-Ygt","modal":"Modal_modal__2J5Ib","closeBtn":"Modal_closeBtn__tX60y"};